angular.module('bmsApp.employee').factory('EmployeeOptionsSvc', function ($q, CRUDSvc, EMPLOYEE_OPTION_API) {

	return {
		employee: function (params) {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.EMPLOYEE, params);
		},
		employeeRole: function () {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.EMPLOYEE_ROLE);
		},
		employeeStatus: function () {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.EMPLOYEE_STATUS);
		},
		employmentType: function () {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.EMPLOYMENT_TYPE);
		},
		remunerationType: function () {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.REMUNERATION_TYPE);
		},
		employeePaymentPeriod: function () {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.EMPLOYEE_PAYMENT_PERIOD);
		},
		employeeMileageRate: function () {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.EMPLOYEE_MILEAGE_RATE);
		},
		employeeGroups: function () {
			return CRUDSvc.get(EMPLOYEE_OPTION_API.EMPLOYEE_GROUPS);
		},
		all: function () {
			var self = this;
			var deferred = $q.defer();

			employeeRole = self.employeeRole();
			employeeStatus = self.employeeStatus();
			employmentType = self.employmentType();
			remunerationType = self.remunerationType();
			employeePaymentPeriod = self.employeePaymentPeriod();
			employeeMileageRate = self.employeeMileageRate();
			employeeGroups = self.employeeGroups();
			$q.all([employeeRole, employeeStatus, employmentType, remunerationType, employeePaymentPeriod, employeeMileageRate, employeeGroups]).then(function (responses) {
				var allResponses = {
					success: true
				};
				allResponses.employeeRole = responses[0].data;
				allResponses.employeeStatus = responses[1].data;
				allResponses.employmentType = responses[2].data;
				allResponses.remunerationType = responses[3].data;
				allResponses.employeePaymentPeriod = responses[4].data;
				allResponses.employeeMileageRate = responses[5].data;
				allResponses.employeeGroups = responses[6].data;
				deferred.resolve(allResponses);
			});

			return deferred.promise;
		}
	};

}).constant('EMPLOYEE_OPTION_API', {
	EMPLOYEE: 'api/employee/options',
	EMPLOYEE_ROLE: 'api/employeeRole/options',
	EMPLOYEE_STATUS: 'api/employeeStatus/options',
	EMPLOYMENT_TYPE: 'api/employmentType/options',
	REMUNERATION_TYPE: 'api/remunerationType/options',
	EMPLOYEE_PAYMENT_PERIOD: 'api/employeePaymentPeriod/options',
	EMPLOYEE_MILEAGE_RATE: 'api/employeeMileageRate/options',
	EMPLOYEE_GROUPS: 'api/employeeGroup/options'
});
